import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'showPassword', 'hidePassword'];

  togglePasswordVisibility () {
    this.inputTarget.type =
      this.inputTarget.type === 'password' ? 'text' : 'password';
    this.showPasswordTarget.classList.toggle('d-none');
    this.hidePasswordTarget.classList.toggle('d-none');
  }
}
